module.exports = "<app-navbar *ngIf=\"showNavbar\"></app-navbar>\n<app-sidemenu *ngIf=\"showsidemenu\"></app-sidemenu>\n<div id=\"wrap\">\n  <router-outlet></router-outlet>\n</div>\n<div [ngClass]=\"messageBox()\">\n  <p class=\"messageBox--msg\">{{messageInfo}}</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main